export interface CampaignSearchState {
  activeDateFromStartDate: string;
  activeDateFromEndDate: string;
  activeDateUntilStartDate: string;
  activeDateUntilEndDate: string;
  campaignCategoryId: number;
  campaignChannel: string;
  campaignName: string;
  campaignSelectionTarget: string;
  campaignStatus: string;
  deactivated: boolean;
  deleted: boolean;
  description: string;
  loyaltySchemaId: number;
  notes: string;
  user: boolean;
  masterData: {
    categories: CampaignSearchCategory[];
    schemas: CampaignSearchSchema[];
    statusTypes: string[];
    targetGroups: string[];
    channels: string[];
    countries: Country[];
  };
  dateTypeFrom: string;
  useTimeFrom: boolean;
  dateTypeUntil: string;
  useTimeUntil: boolean;
  searchPanelExpanded: boolean;
  basicFiltersPanelExpanded: boolean;
  advancedFiltersPanelExpanded: boolean;
  selectedCampaign: any;
  verificationInput: string;
  verificationMismatch: boolean;
  campaignNotes: string;
  duplicateCampaignName: string;
  duplicateCampaignNameMaxLengthExceeded: boolean;
  originalCampaignDeactivation: boolean;
  campaignDeactivation: boolean;
}

export interface CampaignSearchCategory {
  id: number;
  description: string;
}

export interface CampaignSearchSchema {
  id: number;
  loyaltySchemaCode: string;
  loyaltySchemaName: string;
}

export interface StaticData {
  campaignCommunicationChannels: string[];
  campaignExportDataSelections: string[];
  campaignEventTypes: string[];
  operators: string[];
  genders: string[];
  statusTypes: string[];
  campaignSelectionTargetEnum: string[];
  campaignTestFunctionalities: string[];
}
export interface Country {
  id: number
  countryCode: string
  country: string
}

export enum Target {
  LOYALTY_MEMBER = 'LOYALTYMEMBER',
  PERSON = 'PERSON',
}

export enum DATE_SECTOR {
  FROM = 'from',
  UNTIL = 'until'
}

export enum DATE_TYPE {
  SINGLE = 'single',
  RANGE = 'range'
}


export interface CampaignExecution {
  campaignId: number
  campaignExecutionId: number
  campaignName: string
  campaignExecutionTitle: string
  campaignExecutionDescription: string
  campaignExecutionDate: string
  campaignExecutionCountryId: number
  campaignExecutionLoyaltySchemaId: number
  campaignCommunicationChannel: string
  campaignExecutionCost: number
  controGroupPercentage: number
  campaignExecutionLinesCount: number
  progressPercentage: string
  canceled: boolean
}